var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrusselsSprouts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#29384F;}\n\t.st1{fill:#74B757;}\n\t.st2{fill:none;stroke:#428233;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#428233;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.65,109.81c-3.9-6.11-11-10.4-18.22-9.77l-0.16,0.15c-1.6-1.85-3.19-3.7-4.79-5.54 c-1.19,2.47-3.9,3.82-6.55,4.51c-2.65,0.7-5.44,0.93-7.95,2.02c-1.08,0.47-2.23,1.3-2.26,2.48l0.2,0.19 c-0.66-0.3-1.34-0.57-2.03-0.76c-4.66-1.25-9.65-0.24-14.19,1.4c2.46,1.8,3.38,5.1,3.3,8.14c-0.08,3.05-0.97,6.01-1.41,9.02 c-1.65,11.3,3.75,23.34,13.3,29.61s22.73,6.48,32.46,0.49c1.84-1.13,3.56-2.46,5.05-4.02c4.34-4.54,6.54-10.78,7.29-17.01 C132.54,123.54,131.55,115.91,127.65,109.81z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.32,101.64c1.37,1.58,2.76,3.2,3.58,5.13c1.29,3.04,1.01,6.51,0.48,9.77c-0.52,3.26-1.27,6.57-0.83,9.84 c0.44,3.28,1.8,6.25,4.97,7.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128.53,113.42c2.17,5.44,2.45,7.91,1.6,10.85c-1,3.47-3.44,6.5-6.61,8.23c-3.87,2.11-8.51,2.25-12.59,3.92 c-2.3,0.94-5.86,3.95-5.32,6.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.64,130.27c-1.29-0.97-1.68-2.72-1.83-4.33c-0.41-4.57,0.48-9.26,2.52-13.36 c3.62,1.08,7.14,3.17,8.9,6.51c3.01,5.74-0.05,12.7,0.33,19.17c0.24,4.17,2.1,8.35,5.45,10.85s10.27,0.04,13.81-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.39,103.63c3.62,3.62,7.94,8.94,7.94,8.94"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.05,64.51c-4.12-1.52-9.12-0.98-12.38,1.97l-0.02,0.13c-1.45-0.31-2.9-0.61-4.35-0.92 c0.33,1.63-0.49,3.27-1.51,4.58c-1.02,1.31-2.28,2.44-3.1,3.89c-0.35,0.62-0.6,1.44-0.18,2.02l0.17,0.02 c-0.43,0.1-0.85,0.22-1.26,0.38c-2.71,1.11-4.75,3.42-6.34,5.88c1.85-0.03,3.5,1.22,4.58,2.72c1.08,1.5,1.73,3.26,2.63,4.87 c3.35,6.06,10.37,9.89,17.28,9.42c6.91-0.47,13.35-5.21,15.85-11.67c0.47-1.22,0.81-2.5,0.96-3.8c0.43-3.78-0.8-7.6-2.72-10.89 C148.44,69.34,145.17,66.03,141.05,64.51z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M129.2,67.29c1.24,0.26,2.51,0.53,3.61,1.17c1.74,1,2.87,2.77,3.82,4.54c0.94,1.77,1.8,3.64,3.21,5.06 s3.16,2.36,5.04,1.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M142.79,65.93c3.04,1.83,4.08,2.92,4.75,4.65c0.79,2.04,0.72,4.4-0.17,6.4c-1.09,2.44-3.28,4.21-4.64,6.51 c-0.76,1.3-1.38,4.06-0.23,5.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M132.61,86.5c-0.98,0.01-1.81-0.7-2.47-1.42c-1.87-2.06-3.16-4.64-3.68-7.38c2.14-0.81,4.61-1.09,6.68-0.12 c3.56,1.66,4.64,6.15,7.19,9.13c1.65,1.92,4.08,3.26,6.61,3.24c2.53-0.02,4.97-3.75,5.87-6.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M119.35,76.29c3.08,0.42,7.11,1.4,7.11,1.4"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.55,88.16c2.74-1.75,4.66-4.93,4.38-8.16l-0.07-0.07c0.83-0.72,1.66-1.43,2.48-2.15 c-1.1-0.53-1.71-1.75-2.02-2.94c-0.31-1.19-0.42-2.44-0.9-3.56c-0.21-0.49-0.58-1-1.11-1.01l-0.09,0.09 c0.14-0.3,0.25-0.6,0.34-0.91c0.56-2.09,0.11-4.32-0.63-6.36c-0.81,1.1-2.28,1.51-3.65,1.48c-1.36-0.03-2.69-0.44-4.04-0.63 c-5.06-0.74-10.46,1.68-13.27,5.96c-2.81,4.28-2.9,10.18-0.22,14.54c0.51,0.82,1.1,1.6,1.8,2.26c2.03,1.94,4.83,2.93,7.62,3.27 C85.4,90.35,88.81,89.91,91.55,88.16z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M95.21,79.95c-0.71,0.61-1.43,1.24-2.3,1.6c-1.36,0.58-2.92,0.45-4.38,0.22c-1.46-0.23-2.94-0.57-4.41-0.37 c-1.47,0.2-2.8,0.81-3.23,2.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89.93,88.56c-2.44,0.97-3.54,1.1-4.86,0.72c-1.55-0.45-2.91-1.54-3.69-2.96c-0.94-1.73-1.01-3.81-1.76-5.64 c-0.42-1.03-1.77-2.63-2.86-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M82.38,73.37c0.43-0.58,1.22-0.75,1.94-0.82c2.05-0.18,4.15,0.21,5.99,1.13c-0.48,1.62-1.42,3.2-2.92,3.99 c-2.57,1.35-5.69-0.02-8.59,0.15c-1.87,0.11-3.74,0.94-4.86,2.44s-0.02,4.6,0.97,6.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M94.31,70.13c-1.62,1.62-4.01,3.56-4.01,3.56"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrusselsSprouts);
export default __webpack_public_path__ + "static/media/Brussels_Sprouts.1033162ad415b8cd83d90c2fedbd8d4d.svg";
export { ForwardRef as ReactComponent };